"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminDashboardTab = void 0;
const Log_1 = __importDefault(require("@common/Log"));
const PortalTypes_1 = require("@common/types/PortalTypes");
const moment_1 = __importDefault(require("moment"));
const ClassMode_1 = require("../util/ClassMode");
const SortableTable_1 = require("../util/SortableTable");
const UI_1 = require("../util/UI");
const AdminDeliverablesTab_1 = require("./AdminDeliverablesTab");
const AdminPage_1 = require("./AdminPage");
const AdminResultsTab_1 = require("./AdminResultsTab");
const AdminView_1 = require("./AdminView");
const SEARCH_BOX_ATTRS = {
    spellcheck: "false",
    autocomplete: "off",
    autocorrect: "off",
    autocapitalize: "off",
    "data-lpignore": "true",
    "data-1p-ignore": "true",
};
class DashboardTable extends SortableTable_1.SortableTable {
    constructor(headers, divName, afterGenerate) {
        super(headers, divName);
        this.afterGenerate = afterGenerate;
    }
    generate() {
        super.generate();
        this.afterGenerate();
    }
}
class AdminDashboardTab extends AdminPage_1.AdminPage {
    constructor(remote) {
        super(remote);
        this.delivValue = null;
        this.repoValue = null;
        this.histograms = [];
        this.histogramTip = null;
        this.resizeWired = false;
    }
    static selectedView() {
        const select = document.querySelector("#dashboardViewSelect");
        if (select === null) {
            return "all";
        }
        return PortalTypes_1.PERSON_VIEWS.indexOf(select.value) >= 0 ? select.value : "all";
    }
    wireViewSelector() {
        const select = document.querySelector("#dashboardViewSelect");
        if (select === null) {
            return;
        }
        select.onchange = () => {
            this.init({}).catch((err) => {
                Log_1.default.error("AdminDashboardTab::wireViewSelector(..) - ERROR: " + err.message);
            });
        };
    }
    wireDelivSelector(delivs, repos) {
        const select = document.querySelector("#dashboardDelivSelect");
        if (select === null) {
            return;
        }
        select.onchange = () => {
            this.refreshResults(delivs, repos);
        };
    }
    refreshResults(delivs, repos) {
        UI_1.UI.showModal("Retrieving results.");
        this.performQueries()
            .then((newResults) => {
            this.render(delivs, repos, newResults);
            UI_1.UI.hideModal();
        })
            .catch((err) => {
            UI_1.UI.hideModal();
            UI_1.UI.showError(err);
        });
    }
    buildRepoOptions(repos) {
        const names = [];
        for (const repo of repos) {
            names.push(repo.id);
        }
        return names;
    }
    personFilter() {
        return null;
    }
    init(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            Log_1.default.info("AdminDashboardTab::init(..) - start");
            const that = this;
            document.getElementById("dashboardListTable").innerHTML = "";
            UI_1.UI.showModal("Retrieving results.");
            const course = yield AdminView_1.AdminView.getCourse(this.remote);
            if (this.delivValue === null) {
                this.delivValue = (_a = course.defaultDeliverableId) !== null && _a !== void 0 ? _a : "any";
                UI_1.UI.setDropdownOptions("dashboardDelivSelect", [this.delivValue], this.delivValue);
            }
            const delivs = yield AdminDeliverablesTab_1.AdminDeliverablesTab.getDeliverables(this.remote);
            const repos = yield AdminResultsTab_1.AdminResultsTab.getRepositories(this.remote);
            const results = yield this.performQueries();
            UI_1.UI.hideModal();
            this.wireViewSelector();
            this.wireDelivSelector(delivs, repos);
            const fab = document.querySelector("#dashboardUpdateButton");
            fab.onclick = function (_evt) {
                Log_1.default.info("AdminDashboardTab::init(..)::updateButton::onClick");
                that.refreshResults(delivs, repos);
            };
            this.render(delivs, repos, results);
        });
    }
    performQueries() {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminDashboardTab::performQueries(..) - start");
            const start = Date.now();
            let deliv = UI_1.UI.getDropdownValue("dashboardDelivSelect");
            if (deliv === "-Any-") {
                deliv = "any";
            }
            let repo = UI_1.UI.getDropdownValue("dashboardRepoSelect");
            if (repo === "-Any-") {
                repo = "any";
            }
            this.delivValue = deliv;
            this.repoValue = repo;
            const classMode = ClassMode_1.ClassMode.isOn();
            const person = classMode === true ? null : this.personFilter();
            const results = yield AdminDashboardTab.getDashboard(this.remote, deliv, classMode === true || person !== null ? "any" : repo, AdminDashboardTab.selectedView(), person);
            Log_1.default.info("AdminDashboardTab::performQueries(..) - done; # results: " + results.length + "; took: " + UI_1.UI.took(start));
            return results;
        });
    }
    buildHeaders() {
        return [
            {
                id: "timestamp",
                text: "Timestamp",
                sortable: true,
                defaultSort: true,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "?",
                text: "?",
                sortable: false,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "repoId",
                text: "Repository",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: left;",
            },
            {
                id: "delivId",
                text: "Deliv",
                sortable: true,
                defaultSort: false,
                sortDown: false,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "score",
                text: "Score %",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "testScore",
                text: "Correct %",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "coverScore",
                text: "Cover %",
                sortable: true,
                defaultSort: false,
                sortDown: true,
                style: "padding-left: 1em; padding-right: 1em; text-align: center;",
            },
            {
                id: "results",
                text: "Results",
                sortable: false,
                defaultSort: false,
                sortDown: true,
                downloadable: false,
                style: "padding-left: 0.5em; padding-right: 0.5em;",
            },
        ];
    }
    adminLink(url) {
        return url;
    }
    decorateRow(row, result) {
        void result;
        return row;
    }
    render(delivs, repos, results) {
        Log_1.default.trace("AdminDashboardTab::render(..) - start");
        const that = this;
        let delivNames = [];
        for (const deliv of delivs) {
            delivNames.push(deliv.id);
        }
        delivNames = delivNames.sort();
        delivNames.unshift("-Any-");
        UI_1.UI.setDropdownOptions("dashboardDelivSelect", delivNames, this.delivValue);
        let repoNames = this.buildRepoOptions(repos);
        repoNames = repoNames.sort();
        repoNames.unshift("-Any-");
        UI_1.UI.setDropdownOptions("dashboardRepoSelect", repoNames, this.repoValue);
        const headers = AdminDashboardTab.compactColumns(this.buildHeaders());
        this.histograms = [];
        const st = new DashboardTable(headers, "#dashboardListTable", () => this.fitHistograms());
        st.hiddenColumns = ClassMode_1.ClassMode.isOn() === true ? [ClassMode_1.ClassMode.SUBJECT_COLUMN] : [];
        for (const result of results) {
            const ts = result.timestamp;
            const date = new Date(ts);
            const mom = (0, moment_1.default)(date);
            const tsString = mom.format("MM/DD[@]HH:mm");
            const dashRow = this.generateHistogram(result);
            const stdioViewerURL = "/stdio.html?delivId=" + result.delivId + "&repoId=" + result.repoId + "&sha=" + result.commitSHA;
            const commitURL = this.adminLink(result.commitURL);
            const repoURL = this.adminLink(result.repoURL);
            const row = [
                { value: ts, html: "<a class='selectable' href='" + commitURL + "'>" + tsString + "</a>" },
                {
                    value: "",
                    html: "<a style='cursor: pointer;' target='_blank' href='" + stdioViewerURL + "'><ons-icon icon='md-info-outline'</ons-icon></a>",
                },
                {
                    value: result.repoId,
                    html: "<a class='selectable' href='" + repoURL + "'>" + result.repoId + "</a>",
                },
                { value: result.delivId, html: result.delivId },
                { value: result.scoreOverall, html: this.alignValue(result.scoreOverall) },
                { value: result.scoreTests, html: this.alignValue(result.scoreTests) },
                { value: result.scoreCover, html: this.alignValue(result.scoreCover) },
                { value: "", html: dashRow },
            ];
            st.addRow(this.decorateRow(row, result));
        }
        st.generate();
        this.wireHistogramHover();
        this.wireResize();
        try {
            new TomSelect("#dashboardRepoSelect", {
                maxOptions: null,
                maxItems: 1,
                closeAfterSelect: true,
                onInitialize: function () {
                    for (const [attr, value] of Object.entries(SEARCH_BOX_ATTRS)) {
                        this.control_input.setAttribute(attr, value);
                    }
                },
                onDropdownOpen: function () {
                    Log_1.default.trace("AdminDashboardTab::render(..)::repoSelect - Clearing input: " + this);
                    this.setValue("");
                },
                onDropdownClose: function () {
                    Log_1.default.trace("AdminDashboardTab::render(..)::repoSelect - Performing search: " + this);
                    Log_1.default.trace("AdminDashboardTab::render(..)::repoSelect - Search value: " + this.getValue());
                    if (this.getValue() === "") {
                        this.setValue("-Any-");
                    }
                    void that.init({}).then().catch();
                    this.blur();
                },
            });
        }
        catch (err) {
            Log_1.default.trace("AdminDashboardTab::render(..) - updating select; MSG: " + err.message);
        }
        ClassMode_1.ClassMode.showFilter("dashboardRepoLabel", "dashboardRepoSelect", ClassMode_1.ClassMode.isOn() === false);
        if (st.numRows() > 0) {
            UI_1.UI.showSection("dashboardListTable");
            UI_1.UI.hideSection("dashboardListTableNone");
        }
        else {
            UI_1.UI.showSection("dashboardListTable");
            UI_1.UI.hideSection("dashboardListTableNone");
        }
    }
    generateHistogram(row) {
        const tests = AdminDashboardTab.annotateTests(row);
        const id = this.histograms.push(tests) - 1;
        return AdminDashboardTab.histogramHTML(tests, id);
    }
    static annotateTests(row) {
        var _a, _b, _c, _d;
        const passNames = ((_a = row.testPass) !== null && _a !== void 0 ? _a : []);
        const failNames = ((_b = row.testFail) !== null && _b !== void 0 ? _b : []);
        const skipNames = ((_c = row.testSkip) !== null && _c !== void 0 ? _c : []);
        const errorNames = ((_d = row.testError) !== null && _d !== void 0 ? _d : []);
        const fail = new Set(failNames);
        const pass = new Set(passNames);
        const skip = new Set(skipNames);
        const error = new Set(errorNames);
        const all = [].concat(passNames, failNames, skipNames, errorNames).sort();
        const annotated = [];
        for (const name of all) {
            if (fail.has(name)) {
                annotated.push({ name: name, state: "fail", colour: "red" });
            }
            else if (pass.has(name)) {
                annotated.push({ name: name, state: "pass", colour: "green" });
            }
            else if (skip.has(name)) {
                annotated.push({ name: name, state: "skip", colour: "grey" });
            }
            else if (error.has(name)) {
                annotated.push({ name: name, state: "error", colour: "orange" });
            }
            else {
                annotated.push({ name: name, state: "unknown", colour: "black" });
            }
        }
        return annotated;
    }
    static histogramHTML(tests, id) {
        const G = AdminDashboardTab.BAR_GAP;
        const n = tests.length;
        const at = (k) => Number(((k * 100) / n).toFixed(4)) + "%";
        let html = "<div class='histogramcontainer' style='padding: " + AdminDashboardTab.BAR_GAP + "px 0; white-space: nowrap;'>";
        html +=
            "<span class='selectable' style='display: inline-block; box-sizing: content-box; width: " +
                AdminDashboardTab.LABEL_WIDTH +
                "; padding: 0 1px; text-align: center; vertical-align: middle;'>_" +
                tests.length +
                "_</span>";
        if (tests.length > 0) {
            const stops = [];
            let runStart = 0;
            for (let i = 1; i <= n; i++) {
                if (i === n || tests[i].colour !== tests[runStart].colour) {
                    stops.push(tests[runStart].colour + " " + at(runStart) + " " + at(i));
                    runStart = i;
                }
            }
            const mask = "repeating-linear-gradient(to right, #000 0 calc(var(--p) - " + G + "px), transparent calc(var(--p) - " + G + "px) var(--p))";
            html +=
                "<span class='dashHistogram' data-hist='" +
                    id +
                    "' style='--p: " +
                    AdminDashboardTab.BAR_PITCH +
                    "px; display: inline-block; vertical-align: middle; margin-left: " +
                    G +
                    "px; width: calc(var(--p) * " +
                    n +
                    "); height: " +
                    AdminDashboardTab.BAR_HEIGHT +
                    "px; background-image: linear-gradient(to right, " +
                    stops.join(", ") +
                    "); -webkit-mask-image: " +
                    mask +
                    "; mask-image: " +
                    mask +
                    ";'></span>";
        }
        return html + "</div>";
    }
    wireHistogramHover() {
        const container = document.querySelector("#dashboardListTable");
        if (container === null) {
            return;
        }
        container.onmousemove = (evt) => {
            const test = this.testUnderPointer(evt);
            if (test === null) {
                this.hideHistogramTip();
            }
            else {
                this.showHistogramTip(test, evt);
            }
        };
        container.onmouseleave = () => {
            this.hideHistogramTip();
        };
    }
    static compactColumns(headers) {
        var _a;
        for (const header of headers) {
            if (header.id !== "results") {
                const style = ((_a = header.style) !== null && _a !== void 0 ? _a : "").trim();
                header.style =
                    (style === "" || style.endsWith(";") ? style : style + ";") + " padding-left: 0.5em; padding-right: 0.5em; width: 1px;";
            }
        }
        return headers;
    }
    fitHistograms() {
        const container = document.querySelector("#dashboardListTable");
        if (container === null || container.clientWidth === 0) {
            return;
        }
        const table = container.querySelector("table");
        const bars = Array.from(container.querySelectorAll(".dashHistogram"));
        if (table === null || bars.length === 0) {
            return;
        }
        const testsIn = (bar) => { var _a; var _b; return (_b = (_a = this.histograms[Number(bar.dataset.hist)]) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0; };
        const widestMinimum = Math.max(...bars.map((bar) => testsIn(bar) * AdminDashboardTab.MIN_BAR_PITCH));
        for (let pass = 0; pass < 2; pass++) {
            const cell = bars[0].closest("td");
            const cellRect = cell.getBoundingClientRect();
            const beforeBars = bars[0].getBoundingClientRect().left - cellRect.left;
            const afterBars = Number.parseFloat(getComputedStyle(cell).paddingRight) || 0;
            const column = container.clientWidth - (table.getBoundingClientRect().width - cellRect.width);
            const room = Math.max(column - beforeBars - afterBars, widestMinimum);
            for (const bar of bars) {
                const n = testsIn(bar);
                if (n > 0) {
                    const pitch = Math.min(AdminDashboardTab.BAR_PITCH, Math.max(AdminDashboardTab.MIN_BAR_PITCH, room / n));
                    bar.style.setProperty("--p", pitch + "px");
                }
            }
        }
    }
    wireResize() {
        if (this.resizeWired === true) {
            return;
        }
        this.resizeWired = true;
        let queued = false;
        window.addEventListener("resize", () => {
            if (queued === true) {
                return;
            }
            queued = true;
            window.requestAnimationFrame(() => {
                queued = false;
                this.fitHistograms();
            });
        });
    }
    testUnderPointer(evt) {
        var _a;
        var _b;
        const host = (_a = evt.target) === null || _a === void 0 ? void 0 : _a.closest(".histogramcontainer");
        const bar = host === null || host === void 0 ? void 0 : host.querySelector(".dashHistogram");
        if (bar === null || typeof bar === "undefined") {
            return null;
        }
        const tests = this.histograms[Number(bar.dataset.hist)];
        const rect = bar.getBoundingClientRect();
        const x = evt.clientX - rect.left;
        if (typeof tests === "undefined" || x < 0 || x >= rect.width || evt.clientY < rect.top || evt.clientY >= rect.bottom) {
            return null;
        }
        const pitch = Number.parseFloat(bar.style.getPropertyValue("--p")) || AdminDashboardTab.BAR_PITCH;
        return (_b = tests[Math.floor(x / pitch)]) !== null && _b !== void 0 ? _b : null;
    }
    showHistogramTip(test, evt) {
        if (this.histogramTip === null) {
            const tip = document.createElement("div");
            tip.style.cssText =
                "position: fixed; z-index: 10000; pointer-events: none; padding: 2px 6px; border-radius: 3px; " +
                    "background: rgba(0, 0, 0, 0.8); color: white; font-size: 12px; white-space: nowrap; display: none;";
            document.body.appendChild(tip);
            this.histogramTip = tip;
        }
        const tip = this.histogramTip;
        tip.textContent = test.name + " (" + test.state + ")";
        tip.style.display = "block";
        const offset = 12;
        const left = evt.clientX + offset + tip.offsetWidth > window.innerWidth ? evt.clientX - offset - tip.offsetWidth : evt.clientX + offset;
        tip.style.left = Math.max(0, left) + "px";
        tip.style.top = evt.clientY + offset + "px";
    }
    hideHistogramTip() {
        if (this.histogramTip !== null) {
            this.histogramTip.style.display = "none";
        }
    }
    static getDashboard(remote_1, delivId_1, repoId_1) {
        return __awaiter(this, arguments, void 0, function* (remote, delivId, repoId, view = "all", person = null) {
            Log_1.default.info("AdminDashboardTab::getDashboard( .. ) - start");
            const start = Date.now();
            let url = remote + "/portal/admin/dashboard/" + delivId + "/" + repoId + "/" + view;
            if (person !== null && person.length > 0) {
                url += "?person=" + encodeURIComponent(person);
            }
            const options = AdminView_1.AdminView.getOptions();
            const response = yield fetch(url, options);
            if (response.status === 200) {
                Log_1.default.trace("AdminDashboardTab::getDashboard(..) - 200 received");
                const json = yield response.json();
                if (typeof json.success !== "undefined" && Array.isArray(json.success)) {
                    Log_1.default.trace("AdminDashboardTab::getDashboard(..)  - worked; # rows: " + json.success.length + "; took: " + UI_1.UI.took(start));
                    return json.success;
                }
                else {
                    Log_1.default.trace("AdminDashboardTab::getDashboard(..)  - ERROR: " + json.failure.message);
                    AdminView_1.AdminView.showError(json.failure);
                }
            }
            else {
                Log_1.default.trace("AdminDashboardTab::getDashboard(..)  - !200 received: " + response.status);
                const text = yield response.text();
                AdminView_1.AdminView.showError(text);
            }
            return [];
        });
    }
    alignValue(value) {
        const SPACER = "&#8199;";
        if (value === null) {
            return SPACER + SPACER + "N/A";
        }
        if (typeof value === "string") {
            if (value === "N/A") {
                return SPACER + SPACER + "N/A";
            }
            if (value === "") {
                return "";
            }
            value = Number.parseFloat(value);
        }
        const origValue = Number(value);
        let score = "";
        let scorePrepend = "";
        score = Number(value);
        if (score === 100) {
            score = "100.00";
        }
        else {
            if (typeof value === "number") {
                score = value.toFixed(2);
            }
            else {
                Log_1.default.trace("AdminDashboardTab::alignValue(..) - not a number: " + value);
            }
            scorePrepend = SPACER + scorePrepend;
            if (origValue < 10) {
                scorePrepend = SPACER + scorePrepend;
            }
        }
        return scorePrepend + score;
    }
}
exports.AdminDashboardTab = AdminDashboardTab;
AdminDashboardTab.BAR_WIDTH = 7;
AdminDashboardTab.MIN_BAR_WIDTH = 2;
AdminDashboardTab.BAR_GAP = 2;
AdminDashboardTab.BAR_HEIGHT = 22;
AdminDashboardTab.BAR_PITCH = AdminDashboardTab.BAR_WIDTH + AdminDashboardTab.BAR_GAP;
AdminDashboardTab.MIN_BAR_PITCH = AdminDashboardTab.MIN_BAR_WIDTH + AdminDashboardTab.BAR_GAP;
AdminDashboardTab.LABEL_WIDTH = "3.5em";
